import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gift, Activity, Heart, Star, Compass, Sun, Zap } from 'lucide-react';
const features = [{
  icon: BookOpen,
  text: '6 Tomos Digitales'
}, {
  icon: Gift,
  text: '4 Bonus Exclusivos'
}, {
  icon: Activity,
  text: 'Protocolos Prácticos'
}, {
  icon: Zap,
  text: 'Ejercicios Energéticos'
}, {
  icon: Star,
  text: 'Herramientas Espirituales'
}, {
  icon: Sun,
  text: 'Técnicas de Abundancia'
}, {
  icon: Compass,
  text: 'Métodos de Manifestación'
}, {
  icon: Heart,
  text: 'Sistemas de Equilibrio'
}];
export function WhatIsIt() {
  return <section className="py-16 relative z-10 bg-[#0a0517]" data-id="element-141">
      <div className="container mx-auto px-4" data-id="element-142">
        <motion.div className="text-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-143">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-144">
            ¿Qué es{' '}
            <span className="text-gold-gradient" data-id="element-145">Energia Cuantica PRO KIT</span>
            ?
          </h2>
          <p className="text-base text-white/70 max-w-3xl mx-auto" data-id="element-146">
            Un ecosistema digital completo diseñado para elevar tu frecuencia,
            sanar bloqueos profundos y alinearte con la vida que mereces.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-147">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="glass-panel rounded-2xl p-5 flex flex-col items-center text-center" data-id="element-148">
              <div className="w-12 h-12 rounded-full bg-[#7c3aed]/20 flex items-center justify-center mb-3" data-id="element-149">
                <feature.icon className="w-6 h-6 text-[#a855f7]" data-id="element-150" />
              </div>
              <h3 className="text-sm md:text-base font-medium text-white/90" data-id="element-151">
                {feature.text}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}